import React, { useEffect, useState, useContext, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import { useTranslation } from 'react-i18next';

import { NetworkConnectionContext } from 'context/NetworkConnectionContext';

import Alert from 'components/alert';

const NetworkErrorAlert = () => {
    const { t } = useTranslation('errors');

    const networkConnection = useContext(NetworkConnectionContext);
    const [showAlert, setShowAlert] = useState(false);
    const updatedOnce = useRef(false);

    const updateOnlineStatus = status => {
        if (!updatedOnce.current && status === true) {
            return;
        }

        updatedOnce.current = true;

        setShowAlert(true);

        if (navigator.onLine) {
            setTimeout(() => {
                window.location.reload();
            }, 1500);
        }
    }

    useEffect(() => {
        updateOnlineStatus(networkConnection.connected);
    }, [networkConnection.connected]);

    return (
        <React.Fragment>
            {
                showAlert ? (
                    <CSSTransition key="socket-error" timeout={300} classNames="alert">
                        <Alert
                            type={networkConnection.connected ? 'success' : 'error'}
                            icon={networkConnection.connected ? <i className="icon material-icons">check_circle</i> : <i className="icon material-icons">error</i>}
                            visible={true}
                            noClose={true}
                        >
                            {
                                networkConnection.connected ? t('network.resolved') : t('network.error')
                            }
                        </Alert>
                    </CSSTransition>
                ) : null
            }
        </React.Fragment>
    )
}

export default NetworkErrorAlert;
